import React from "react";
import PropTypes from "prop-types";
import UserIcon from "./UserIcon";
import RatingStars from "./RatingStars";

const SingleComment = ( { name, rating, emoji, comment, date } ) => {
  return (
    <li className="single-comment">
      <div className="top-info">
        <UserIcon emoji={emoji}/>
        <div className="user">
          <div className="name">{name}</div>
          <div className="rating-date">
            <div className="rating-stars">
              <RatingStars rating={rating} cssClass="rating-active"/>
              <RatingStars rating={"5"} cssClass="rating-passive"/>
            </div>
            <span className="date">{date}</span>
          </div>
        </div>
      </div>
      <div className="comment" dangerouslySetInnerHTML={{ __html: comment }}/>
    </li>
  );
};

export default SingleComment;

SingleComment.propTypes = {
  name: PropTypes.string,
  rating: PropTypes.string,
  emoji: PropTypes.string,
  comment: PropTypes.string,
  date: PropTypes.string,
};
